<template>
    <x-dialog
        custom-class="x-file-preview"
        :visible="visible"
        :config="getDialogConfig(config)"
        @close="$emit('close')"
        @update:visible="(visible) => $emit('update:visible', visible)"
    >
        <div class="x-preview-dialog">
            <img v-if="imgSrc" class="content" :src="imgSrc" alt="" />
        </div>
    </x-dialog>
</template>
<script setup>
import { getCurrentInstance, onMounted, ref } from "vue";
import XDialog from "../../dialog/XDialog.vue";
import { Base64 } from "js-base64";
import { useTokenStore } from "../../store/TokenStore";
import axios from 'axios';
const useToken = useTokenStore()
const inst = getCurrentInstance();

const props = defineProps({
    visible: { default: true },
    uri: { default: null },
    fileName: { default: null },
    config: { default: {} }
});
const imgSrc = ref(null);
defineEmits({
    close: null,
    "update:visible": null
});
const getFileUrlType = (fn) => {
    const ext = fn.replace(/.*\./, "");
    switch (ext) {
        case "png":
        case "jpeg":
        case "jpg":
        case "bmp":
        case "mp4":
        case "mp3":
        case "flv":
            return window.location.origin;
        default:
            return "http://127.0.0.1:5900";
    }
};
onMounted(() => {
    axios({
        url:
           "/dev-api/ebk/ebkResource/download/" +
            Base64.encode(props.uri),
        headers: {
            Authorization: "Bearer " + useToken.token
        },
        responseType: "blob"
    }).then((res) => {
        const url = URL.createObjectURL(new Blob([res.data]));
        imgSrc.value = url;
    });
});
const getCurrentPreviewUrl = async (uri, fileName) => {
    const res = await axios({
        url:
            "/dev-api/ebk/ebkResource/download/" +
            Base64.encode(props.uri),
        headers: {
            Authorization: "Bearer " + useToken.token
        },
        responseType: "blob"
    });
    const url = URL.createObjectURL(new Blob([res.data]));
    return url;
    // const url = getFileUrlType(fileName) + '/dev-api/ebk/ebkResource/download/' + Base64.encode(uri)
    // const previewUrl = window.location.origin + '/file-preview/onlinePreview?url=' + encodeURIComponent(Base64.encode(url));
    // return previewUrl;
};

const getDialogConfig = (config) => {
    if (!config) return null;
    if (!config.width) config.width = 1200;
    config.withDefaultButtons = false;
    config.title = "预览";
    config.fullscreen = true;
    return config;
};

const keydownHandler = (event) => {
    console.log(event);
};
</script>
<style scoped>
.x-preview-dialog{
    text-align: center;
}
.x-preview-dialog >>> iframe {
    border: 0;
    width: 100%;
    box-sizing: border-box;
    min-height: 800px;
   
    /* min-height: 800px; */
}
</style>
<style>
.x-file-preview {
    background: #00000099;
}
.x-file-preview .el-dialog__title {
    color: #fff;
}
</style>
